type InferArguments<T> = T extends (...args: infer R) => any ? R : never
type InferReturnValue<T> = T extends (...args: any) => infer R ? R : never

// Shallow comparison
export function getCachedFunctionReturnValue<T extends Function>(
  func: T
): (...args: InferArguments<T>) => InferReturnValue<T> {
  // Ignoring detect context change for now
  let cachedDependenciesAndValue: Map<any, any> = new Map()

  return function (this: any, ...args: InferArguments<T>): InferReturnValue<T> {
    const hasChange = args.some((arg, index) => {
      return cachedDependenciesAndValue.get(index) !== arg
    })

    if (!hasChange && cachedDependenciesAndValue.has('value')) {
      return cachedDependenciesAndValue.get('value')
    }

    // Free up memory
    cachedDependenciesAndValue = new Map()

    const value = func.apply(this, args)
    args.forEach((arg, index) => {
      cachedDependenciesAndValue.set(index, arg)
    })
    cachedDependenciesAndValue.set('value', value)
    return value
  }
}
